import { CreateNoteDto } from '@lmt/shared-types';

export enum NoteType {
  NoDate = 0,
  OneDay = 1,
  Period = 2,
}

export type NoteFormData = CreateNoteDto & { noteType: NoteType };
